export enum AnalyticsAccountEvents {
    login ="Log in", // V
    logout = "Log out", // V
    addPlan = "Add plan", // V
    cancelPlan = "Cancel plan", // V
    cancelPlanSubmit = "Cancel plan submit", // V
    managePlan = "Manage plan", // V
    managePlanSubmit = "Manage plan submit", // V
    addRentPlan = "Add rent plan", // V
    deferPayment = "Defer payment request", // V
    onBoardingStarted = "On boarding started", // V
    onBoardingEnded = "On boarding ended", // V
    onBoardingSkipped = "On boarding skipped", // V
    notificationOpened = "Notification opened"
}


// WEBPACK FOOTER //
// ./src/services/Analytics/AnalyticsAccountEvents.ts